import incomeTypeEnum from "constants/incomeTypeEnum";


const FormObserver = (formRef) => {

  formRef.$("target_amount_type").observe({
    key: "value",
    call: ({ form, field }) => {
      let type = field.value.mode;

      form.$("target_amount_dropdown").value = {}

      let incomeList = form.$("target_amount_dropdown").extra.allOptionsList.filter(item => item.mode === incomeTypeEnum.INCOME)

      let lumpsumList = form.$("target_amount_dropdown").extra.allOptionsList.filter(item => item.mode === incomeTypeEnum.LUMPSUM)


      if (type === incomeTypeEnum.INCOME) {
        form.$("target_amount_dropdown").set("extra", {
          ...form.$("target_amount_dropdown").extra,
          optionList: incomeList,
        })

        let productList = form.$("products_list").extra.preDefinedOptList
        let filterProductList = productList.filter(item => item.payout_type.toLowerCase() === incomeTypeEnum.INCOME.toLowerCase())

        form.$("products_list").set("extra", {
          ...form.$("products_list").extra,
          optionList: filterProductList ? filterProductList : []
        })
        // form.$("products_list").set("value", filterProductList[0])
      }

      if (type === incomeTypeEnum.LUMPSUM) {
        form.$("target_amount_dropdown").set("extra", {
          ...form.$("target_amount_dropdown").extra,
          optionList: lumpsumList,
        })

        let productList = form.$("products_list").extra.preDefinedOptList
        let filterProductList = productList.filter(item => item.payout_type.toLowerCase()  === incomeTypeEnum.LUMPSUM.toLowerCase())

        form.$("products_list").set("extra", {
          ...form.$("products_list").extra,
          optionList: filterProductList ? filterProductList : []
        })
        // form.$("products_list").set("value", filterProductList[0])
      }
    }
  });
}

export default FormObserver